import { useState, useEffect, useCallback } from "react"
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import useTableStore from "../store/table";
import axios from "../axios";
import { debounce } from "lodash";

const mockRows = [
  {
    id: 1,
    name: 'item 1',
    price: 100,
    quantity: 10
  },
  {
    id: 2,
    name: 'item 2',
    price: 200,
    quantity: 20
  }
];

const useTableLoad = ({ defaultSort, rowsPerPage, tabs, tabField, defaultTab = '', tableId, headers, additionalCollections = '' }) => {
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage
  });

  const [sort, setSort] = useState(defaultSort);

  const [query, setQuery] = useState({
    tab: {[tabField]: defaultTab},
  });

  // const [searchTerm, setSearchTerm] = useState('');

  const getSortedColumns = (storedColumns, headers) => {
    let newColumns = headers;
    if (storedColumns.length) {
      newColumns = storedColumns.map(cur => cur.active && headers.find(header => header.id === cur.id)).filter(cur => cur);
    }
    return newColumns;
  }

  const fs = useTableStore(state => state.tableFilterString);

  const filterString = useTableStore(state => state.tableFilterString[tableId]);
  const setTableFinalQueryString = useTableStore(state => state.setTableFinalQueryString);
  const storedTableColumns = useTableStore(state => state.tableColumnSort[tableId]) || []
  const sortedColumns = getSortedColumns(storedTableColumns, headers)

  const tableSearchTerm = useTableStore(state => state.tableSearchTerm[tableId])
  const setTableSearchTerm = useTableStore(state => state.setTableSearchTerm)

  const tableSearchTermDebounced = useTableStore(state => state.tableSearchTermDebounced[tableId])
  const setTableSearchTermDebounced = useTableStore(state => state.setTableSearchTermDebounced)

  const searchList = useCallback(debounce(async (e) => {
    let value = e.target.value;
    setTableSearchTermDebounced(tableId, value);
  }, 250), [setTableSearchTermDebounced]) 

  const handleSearch = (e) => {
    setTableSearchTerm(tableId, e.target.value);
    searchList(e);
  }

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [tableId, filterString, sort, pagination, tableSearchTermDebounced, query], 
    queryFn: () => load(),
    placeholderData: keepPreviousData
  });

  const handleTabs = (tab, isCustom) => {
    const tabId = tabs[tab]?.id;
    if (!tabId) {
      return;
    }
    setQuery((prevQuery) => {
      const newQuery = { ...prevQuery };
      newQuery.tab = {[tabField]: tabId};
      console.log(newQuery, "isCustom");
      if (isCustom) {
        newQuery.custom = true;
      } else {
        delete newQuery.custom;
      }
      return newQuery;
    });
  };

  // const handleSort = (sort, flag = true) => {
  //   setSort((prevSort) => {
  //     const newSort = [...prevSort];
  //     if (flag) {
  //       newSort.unshift(sort);
  //     } else {
  //       newSort.splice(newSort.indexOf(sort), 1);
  //     }
  //     return newSort;
  //   });
  // }

  const handleSort = (id) => {
    setSort(os => {
      if (!os) return id;

      let osOpts = os.split("-");
      let sortDir = osOpts.length > 1 ? 'desc' : 'asc';
      let field = osOpts[0] || osOpts[1]
      if (id === field) {
        return sortDir === 'desc' ? `${id}` : `-${id}`
      } else {
        return id;
      }
    })
  }

  const getQueries = (query) => {
    let queryString = "";
    // iterate through query object
    for (let key in query) {
      // if query value is not an object (primitive), append to queryString
      if (typeof query[key] !== "object") {
        queryString += `&${key}=${query[key]}`;
      } else if (query[key] instanceof Date) {
        queryString += `&${key}=${query[key].toISOString()}`; // Convert date to ISO string
      } else if (Array.isArray(query[key])) { // if query value is an array, join values and append to queryString
        queryString += `&${key}=${query[key].join(",")}`;
      } else { // if query value is an object, iterate through object and append to queryString
        for (let subKey in query[key]) {
          let value = Array.isArray(query[key][subKey]) ? query[key][subKey].join(",") : query[key][subKey]; // if value is an array, join values
          queryString += `&${key}[${subKey}]=${value}`;
        }
      }
    }
    return queryString;
  }

  const constructQuery = (url) => {
    // let queryString = `?sort=${sort.join(" ")}&page=${pagination.page}&limit=${pagination.rowsPerPage}`;
    let queryString = `?sort=${sort}&page=${pagination.page}&limit=${pagination.rowsPerPage}`;
    let additionalQueries = getQueries(query);
    queryString += additionalQueries;
    queryString += filterString || "";
    queryString += tableSearchTermDebounced ? `&term[search]=${encodeURIComponent(tableSearchTermDebounced)}` : '';
    if (additionalCollections) {
      queryString += `&term[additionalCollections]=${additionalCollections}`;
    }
    let fq = `${additionalQueries || ""}${filterString || ""}`
    fq = fq.charAt(0) === '&' ? fq.slice(1) : fq
    setTableFinalQueryString(url, fq);
    return `${url}${queryString}`;
  }


  const load = async () => {
    try {
      let url = constructQuery(tableId);
      const { data } = await axios.get(url);
      return data;
    } catch (e) {
      return {rows: mockRows, pages: 2000};
    }
  }

  return { query, pagination, setPagination, 
    // handleFilter, resetFilter, 
    handleTabs, handleSort, data, sort, isLoading, isError, error, sortedColumns, handleSearch };

};

export default useTableLoad;